import { config } from "../../config"
import type {
  MapViewerAction,
  MapViewerLastViewed,
  MapViewerPanel,
  MapViewerPanelAction,
  MapViewerZoomAction
} from "./map-viewer.types"

export const MAP_VIEWER_INCREASE_ZOOM: string = "MAP_VIEWER_INCREASE_ZOOM"
export const MAP_VIEWER_DECREASE_ZOOM: string = "MAP_VIEWER_DECREASE_ZOOM"
export const MAP_VIEWER_SET_ZOOM: string = "MAP_VIEWER_SET_ZOOM"
export const MAP_VIEWER_TOGGLE_PANEL: string = "MAP_VIEWER_TOGGLE_PANEL"
export const MAP_VIEWER_SWITCH_EDIT_PANEL: string = "MAP_VIEWER_SWITCH_EDIT_PANEL"
export const MAP_VIEWER_SWITCH_ACTION_PANEL: string = "MAP_VIEWER_SWITCH_ACTION_PANEL"
export const MAP_VIEWER_CLEAR_ACTION_PANEL: string = "MAP_VIEWER_CLEAR_ACTION_PANEL"
export const MAP_VIEWER_CLEAR_EDIT_PANELS: string = "MAP_VIEWER_CLEAR_EDIT_PANELS"
export const MAP_VIEWER_ADD_TO_LAST_VIEWED: string = "MAP_VIEWER_ADD_TO_LAST_VIEWED"

export function mapViewerIncreaseZoom(mapId: string): MapViewerZoomAction {
  return { type: MAP_VIEWER_INCREASE_ZOOM, mapId }
}

export function mapViewerDecreaseZoom(mapId: string): MapViewerZoomAction {
  return { type: MAP_VIEWER_DECREASE_ZOOM, mapId }
}

export function mapViewerSetZoom(mapId: string, zoom?: number): MapViewerZoomAction {
  return { type: MAP_VIEWER_SET_ZOOM, payload: zoom, mapId }
}

export function mapViewerTogglePanel(panel: MapViewerPanel, open: boolean): MapViewerPanelAction {
  return { type: MAP_VIEWER_TOGGLE_PANEL, payload: { panel, open } }
}

export function mapViewerSwitchEditPanel(panel: MapViewerPanel): MapViewerPanelAction {
  return { type: MAP_VIEWER_SWITCH_EDIT_PANEL, payload: panel }
}

export function mapViewerSwitchActionPanel(panel: MapViewerPanel): MapViewerPanelAction {
  return { type: MAP_VIEWER_SWITCH_ACTION_PANEL, payload: panel }
}

export function mapViewerClearActionPanels(): MapViewerPanelAction {
  return { type: MAP_VIEWER_CLEAR_ACTION_PANEL }
}

export function mapViewerClearEditPanels(): MapViewerPanelAction {
  return { type: MAP_VIEWER_CLEAR_EDIT_PANELS }
}

export function mapViewerAddToLastViewed(mapId: string, mapUrl: string, title: string): MapViewerAction {
  const items: MapViewerLastViewed[] = getLastViewed()

  if (!isLastViewed(mapId, items)) {
    items.push({ mapId, mapUrl, title })
  }

  if (items.length === config.lastViewedMaxItems + 1) {
    items.shift()
  }

  localStorage.setItem(config.lastViewedMapsLocalstorageKey, JSON.stringify(items))

  return { type: MAP_VIEWER_ADD_TO_LAST_VIEWED }
}

export function getLastViewed(): MapViewerLastViewed[] {
  const localstorageContent: string | null = localStorage.getItem(config.lastViewedMapsLocalstorageKey)

  if (localstorageContent !== null) {
    return JSON.parse(localstorageContent)
  }

  return []
}

function isLastViewed(mapId: string, items: MapViewerLastViewed[]): boolean {
  return items.find((lastViewed: MapViewerLastViewed) => lastViewed.mapId === mapId) !== undefined
}
